import { useDetailPageBreadcrumbs } from 'shared/libs/hooks/useDetailPageBreadcrumbs'

import { useParams } from 'react-router-dom'

import ClientDetailBody from 'modules/Clients/components/ClientDetailBody'
import ClientDetailHeader from 'modules/Clients/components/ClientDetailHeader'
import { useClientHeaderInfo } from 'modules/Clients/hooks/useClientHeaderInfo'

import SkeletonNode from 'shared/ui/SkeletonNode'
import Title from 'shared/ui/Title'

const ClientsDetailWrapper = () => {
  const { clientId } = useParams()
  const { clientDetail, isFetching } = useClientHeaderInfo({
    clientId,
  })

  useDetailPageBreadcrumbs({
    key: 'clientId',
    label: clientDetail?.full_name,
  })

  return (
    <div className="flex-1 flex flex-col">
      <div className="h-[40px] flex items-center justify-between mt-[12px]">
        <SkeletonNode
          loading={isFetching}
          className="!h-10 !w-96"
        >
          <Title
            className="!mb-0 !font-bold !leading-[32px] !text-dark_2"
            level={3}
          >
            {clientDetail?.full_name}
          </Title>
        </SkeletonNode>
      </div>
      <div className="flex-1 flex flex-col gap-[20px] mt-[40px]">
        <ClientDetailHeader
          clientDetail={clientDetail}
          isFetching={isFetching}
        />
        <ClientDetailBody />
      </div>
    </div>
  )
}

export default ClientsDetailWrapper
